import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getTeacherInfoByOid } from '@/api';

const MessageAvatar = (props) => {
  const {
    className,
    // fromMe,
    senderType,
    senderOid,
  } = props;
  // const [senderName, setSenderName] = useState('');
  const [avatar, setAvatar] = useState(props.avatar);

  useEffect(() => {
    if (!senderOid || !senderType) {
      return;
    }
    switch (senderType) {
        case 'Student':
        // TODO 获取学生的头像、姓名
          break;
        case 'Teacher':
          getTeacherInfoByOid(senderOid).then((teacherInfo) => {
            if (!teacherInfo) {
              return;
            }
            // setSenderName((n) => teacherInfo.name || n);
            setAvatar((ava) => teacherInfo.avatar || ava);
          });
          break;
        default:
          break;
    }
  }, [senderOid, senderType]);

  return (
    <div className={className}>
      {avatar && <img src={avatar} alt="" data-no-preview="true" />}
    </div>
  );
};

MessageAvatar.propTypes = {
  className: PropTypes.string,
  avatar: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  fromMe: PropTypes.bool,
  senderType: PropTypes.string,
  senderOid: PropTypes.string,
};


export default MessageAvatar;
